import React from 'react';
import './SkeletonLoader.css';

const SkeletonLoader = ({
  width = '100%',
  height = '20px',
  borderRadius = '4px',
  marginBottom = '0',
  marginRight = '0',
  variant = 'box',
  style = {}
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'text':
        return 'skeleton-text';
      case 'input':
        return 'skeleton-input';
      case 'button':
        return 'skeleton-button';
      case 'radio':
        return 'skeleton-radio';
      case 'image':
        return 'skeleton-image';
      default:
        return 'skeleton-box';
    }
  };

  return (
    <div
      className={`skeleton-loader ${getVariantClass()}`}
      style={{
        width,
        height,
        borderRadius,
        marginBottom,
        marginRight,
        ...style
      }}
    />
  );
};

// Componentes especializados para uso común
export const SkeletonText = ({ width = '100%', lines = 1, ...props }) => {
  if (lines === 1) {
    return <SkeletonLoader width={width} height="16px" borderRadius="4px" variant="text" {...props} />;
  }

  return (
    <div>
      {Array.from({ length: lines }).map((_, index) => (
        <SkeletonLoader
          key={index}
          width={index === lines - 1 ? '80%' : '100%'}
          height="16px"
          borderRadius="4px"
          marginBottom={index < lines - 1 ? '8px' : '0'}
          variant="text"
          {...props}
        />
      ))}
    </div>
  );
};

export const SkeletonInput = (props) => (
  <SkeletonLoader height="52px" borderRadius="10px" variant="input" {...props} />
);

export const SkeletonButton = (props) => (
  <SkeletonLoader height="56px" borderRadius="8px" variant="button" {...props} />
);

export const SkeletonRadio = (props) => (
  <SkeletonLoader height="64px" borderRadius="5px" variant="radio" {...props} />
);

export const SkeletonImage = ({ size = '64px', ...props }) => (
  <SkeletonLoader
    width={size}
    height={size}
    borderRadius="8px"
    variant="image"
    {...props}
  />
);

export default SkeletonLoader;
